import { ETypePersonneJuridique } from "common/enums/ClientSheet/ETypePersonneJuridique";
import { useOutletContext, useParams } from "react-router-dom";

import { IDocumentTemplateSubscriptionOutletContext } from "..";
import TemplateFiles from "../TemplateFiles";

export default function TemplateCorporation() {
	const { productId } = useParams();

	const context = useOutletContext<IDocumentTemplateSubscriptionOutletContext>();

	if (!productId || !context?.documentTypes) return null;

	return <TemplateFiles documentTypes={context.documentTypes.personne_morale} typePersonneJuridique={ETypePersonneJuridique.personne_morale} productId={productId} />;
}
